export type Marina = {
  id: string;
  name: string;
  town: string;
  regionSlug: string;
  berths: number;
  depth: string;
  facilities: string[];
  vhfChannel: string;
  image: string;
  coordinates: { lat: number; lng: number };
  website: string;
};

export type SailingRoute = {
  id: string;
  name: string;
  duration: string;
  distance: string;
  difficulty: "Easy" | "Moderate" | "Challenging";
  descriptionEn: string;
  descriptionDe?: string;
  descriptionFr?: string;
  descriptionIt?: string;
  descriptionNl?: string;
  highlights: string[];
  startPoint: string;
  endPoint: string;
  gygSearchTerm: string;
};

export const MARINAS: Marina[] = [
  // ISTRIA
  {
    id: "aci-umag",
    name: "ACI Marina Umag",
    town: "Umag",
    regionSlug: "istria",
    berths: 475,
    depth: "2–6 m",
    facilities: ["Fuel dock", "Water", "Electricity", "Wi-Fi", "Crane", "Repairs", "Restaurant", "Showers", "Laundry"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Umag.jpg/1280px-Umag.jpg",
    coordinates: { lat: 45.4327, lng: 13.5194 },
    website: "https://www.aci-marinas.com/marina/aci-umag/",
  },
  {
    id: "aci-rovinj",
    name: "ACI Marina Rovinj",
    town: "Rovinj",
    regionSlug: "istria",
    berths: 380,
    depth: "2–8 m",
    facilities: ["Fuel dock", "Water", "Electricity", "Wi-Fi", "Crane", "Repairs", "Restaurant", "Showers", "Laundry"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Rovinj%2C_Croatia.jpg/1280px-Rovinj%2C_Croatia.jpg",
    coordinates: { lat: 45.0814, lng: 13.6354 },
    website: "https://www.aci-marinas.com/marina/aci-rovinj/",
  },
  {
    id: "aci-pula",
    name: "ACI Marina Pula",
    town: "Pula",
    regionSlug: "istria",
    berths: 196,
    depth: "2–7 m",
    facilities: ["Fuel dock", "Water", "Electricity", "Wi-Fi", "Crane", "Repairs", "Restaurant", "Showers"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Veruda.JPG/1280px-Veruda.JPG",
    coordinates: { lat: 44.8567, lng: 13.8376 },
    website: "https://www.aci-marinas.com/marina/aci-pula/",
  },
  {
    id: "aci-pomer",
    name: "ACI Marina Pomer",
    town: "Pomer",
    regionSlug: "istria",
    berths: 292,
    depth: "2–5 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Parking", "Restaurant nearby"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Veruda.JPG/1280px-Veruda.JPG",
    coordinates: { lat: 44.8289, lng: 13.9044 },
    website: "https://www.aci-marinas.com/marina/aci-pomer/",
  },
  // KVARNER
  {
    id: "aci-opatija",
    name: "ACI Marina Opatija",
    town: "Opatija (Ičići)",
    regionSlug: "kvarner",
    berths: 318,
    depth: "3–8 m",
    facilities: ["Fuel dock", "Water", "Electricity", "Wi-Fi", "Crane", "Repairs", "Restaurant", "Showers", "Laundry"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Opatija_panorama.jpg/1280px-Opatija_panorama.jpg",
    coordinates: { lat: 45.3139, lng: 14.3028 },
    website: "https://www.aci-marinas.com/marina/aci-opatija/",
  },
  {
    id: "aci-cres",
    name: "ACI Marina Cres",
    town: "Cres",
    regionSlug: "kvarner",
    berths: 109,
    depth: "2–6 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Fuel nearby", "Restaurant", "Apartments"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Cres_marina.jpg/1280px-Cres_marina.jpg",
    coordinates: { lat: 44.9578, lng: 14.4086 },
    website: "https://www.aci-marinas.com/marina/aci-cres/",
  },
  {
    id: "aci-supetarska-draga",
    name: "ACI Marina Supetarska Draga",
    town: "Supetarska Draga",
    regionSlug: "kvarner",
    berths: 278,
    depth: "2–5 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Parking"],
    vhfChannel: "17",
    image: "/marinas/supetarska-draga.webp",
    coordinates: { lat: 44.7750, lng: 14.6592 },
    website: "https://www.aci-marinas.com/marina/aci-supetarska-draga/",
  },
  {
    id: "aci-rab",
    name: "ACI Marina Rab",
    town: "Rab",
    regionSlug: "kvarner",
    berths: 200,
    depth: "2–6 m",
    facilities: ["Fuel dock", "Water", "Electricity", "Wi-Fi", "Crane", "Repairs", "Restaurant", "Showers"],
    vhfChannel: "17",
    image: "/marinas/rab.jpg",
    coordinates: { lat: 44.7572, lng: 14.7636 },
    website: "https://www.aci-marinas.com/marina/aci-rab/",
  },
  {
    id: "aci-simuni",
    name: "ACI Marina Šimuni",
    town: "Šimuni (Pag)",
    regionSlug: "kvarner",
    berths: 202,
    depth: "2–5 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Apartments", "Parking"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Pag_%28HR%29%2C_%C5%A0imuni_Marina_--_2022_--_0136.jpg/1280px-Pag_%28HR%29%2C_%C5%A0imuni_Marina_--_2022_--_0136.jpg",
    coordinates: { lat: 44.5453, lng: 14.9064 },
    website: "https://www.aci-marinas.com/marina/aci-simuni/",
  },
  // DALMATIA – ŠIBENIK REGION
  {
    id: "aci-zut",
    name: "ACI Marina Žut",
    town: "Žut (Kornati)",
    regionSlug: "dalmatia",
    berths: 120,
    depth: "2–5 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Fuel nearby"],
    vhfChannel: "17",
    image: "/marinas/zut.jpg",
    coordinates: { lat: 43.8725, lng: 15.2925 },
    website: "https://www.aci-marinas.com/marina/aci-zut/",
  },
  {
    id: "aci-piskera",
    name: "ACI Marina Piškera",
    town: "Piškera (Kornati)",
    regionSlug: "dalmatia",
    berths: 88,
    depth: "2–4 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Fuel nearby"],
    vhfChannel: "17",
    image: "/marinas/piskera.jpg",
    coordinates: { lat: 43.7858, lng: 15.3992 },
    website: "https://www.aci-marinas.com/marina/aci-piskera/",
  },
  {
    id: "aci-jezera",
    name: "ACI Marina Jezera",
    town: "Jezera (Murter)",
    regionSlug: "dalmatia",
    berths: 192,
    depth: "2–5 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Parking"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Murter.jpg/1280px-Murter.jpg",
    coordinates: { lat: 43.7939, lng: 15.6514 },
    website: "https://www.aci-marinas.com/marina/aci-jezera/",
  },
  {
    id: "aci-vodice",
    name: "ACI Marina Vodice",
    town: "Vodice",
    regionSlug: "dalmatia",
    berths: 297,
    depth: "2–6 m",
    facilities: ["Fuel dock", "Water", "Electricity", "Wi-Fi", "Crane", "Repairs", "Restaurant", "Showers"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Vodice.jpg/1280px-Vodice.jpg",
    coordinates: { lat: 43.7600, lng: 15.7800 },
    website: "https://www.aci-marinas.com/marina/aci-vodice/",
  },
  {
    id: "aci-skradin",
    name: "ACI Marina Skradin",
    town: "Skradin",
    regionSlug: "dalmatia",
    berths: 136,
    depth: "2–5 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Krka NP access"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Skradin.jpg/1280px-Skradin.jpg",
    coordinates: { lat: 43.8189, lng: 15.9228 },
    website: "https://www.aci-marinas.com/marina/aci-skradin/",
  },
  // DALMATIA – SPLIT REGION
  {
    id: "aci-trogir",
    name: "ACI Marina Trogir",
    town: "Trogir",
    regionSlug: "dalmatia",
    berths: 140,
    depth: "2–5 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Old town access"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/b/bd/Trogir.jpg",
    coordinates: { lat: 43.5136, lng: 16.2494 },
    website: "https://www.aci-marinas.com/marina/aci-trogir/",
  },
  {
    id: "aci-split",
    name: "ACI Marina Split",
    town: "Split",
    regionSlug: "dalmatia",
    berths: 318,
    depth: "2–6 m",
    facilities: ["Fuel dock", "Water", "Electricity", "Wi-Fi", "Crane", "Repairs", "Restaurant", "Showers", "Laundry", "Blue Flag"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Split_from_Marjan.jpg/1280px-Split_from_Marjan.jpg",
    coordinates: { lat: 43.5045, lng: 16.4317 },
    website: "https://www.aci-marinas.com/marina/aci-split/",
  },
  {
    id: "aci-milna",
    name: "ACI Marina Milna",
    town: "Milna (Brač)",
    regionSlug: "dalmatia",
    berths: 192,
    depth: "2–6 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Apartments", "Parking"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/MILNA_PORT.JPG/1280px-MILNA_PORT.JPG",
    coordinates: { lat: 43.3289, lng: 16.4514 },
    website: "https://www.aci-marinas.com/marina/aci-milna/",
  },
  {
    id: "aci-vrboska",
    name: "ACI Marina Vrboska",
    town: "Vrboska (Hvar)",
    regionSlug: "dalmatia",
    berths: 119,
    depth: "2–5 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Parking"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/0/0d/Vrboska.jpg",
    coordinates: { lat: 43.1817, lng: 16.6800 },
    website: "https://www.aci-marinas.com/marina/aci-vrboska/",
  },
  {
    id: "aci-palmizana",
    name: "ACI Marina Palmižana",
    town: "Palmižana (Hvar)",
    regionSlug: "dalmatia",
    berths: 185,
    depth: "2–5 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Fuel nearby"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Palmizana.jpg/1280px-Palmizana.jpg",
    coordinates: { lat: 43.1603, lng: 16.3953 },
    website: "https://www.aci-marinas.com/marina/aci-palmizana/",
  },
  // DALMATIA – DUBROVNIK REGION
  {
    id: "aci-korcula",
    name: "ACI Marina Korčula",
    town: "Korčula",
    regionSlug: "dalmatia",
    berths: 152,
    depth: "2–6 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Old town access"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/f/f7/Korcula.jpg",
    coordinates: { lat: 42.9606, lng: 17.1353 },
    website: "https://www.aci-marinas.com/marina/aci-korcula/",
  },
  {
    id: "aci-slano",
    name: 'ACI Marina "Veljko Barbieri" Slano',
    town: "Slano",
    regionSlug: "dalmatia",
    berths: 141,
    depth: "2–5 m",
    facilities: ["Water", "Electricity", "Wi-Fi", "Showers", "Restaurant", "Parking"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Croatia_BW_2014-10-10_12-34-29.jpg/1280px-Croatia_BW_2014-10-10_12-34-29.jpg",
    coordinates: { lat: 42.7836, lng: 17.8911 },
    website: "https://www.aci-marinas.com/marina/aci-veljko-barbieri-slano/",
  },
  {
    id: "aci-dubrovnik",
    name: "ACI Marina Dubrovnik",
    town: "Dubrovnik (Komolac)",
    regionSlug: "dalmatia",
    berths: 430,
    depth: "2–8 m",
    facilities: ["Fuel dock", "Water", "Electricity", "Wi-Fi", "Crane", "Repairs", "Chandlery", "Restaurant", "Showers", "Laundry"],
    vhfChannel: "17",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Dubrovnik_as_seen_from_Sr%C4%91_-_September_2017.jpg/1280px-Dubrovnik_as_seen_from_Sr%C4%91_-_September_2017.jpg",
    coordinates: { lat: 42.6413, lng: 18.0724 },
    website: "https://www.aci-marinas.com/marina/aci-dubrovnik/",
  },
];

export const SAILING_ROUTES: SailingRoute[] = [
  {
    id: "split-dubrovnik",
    name: "Split to Dubrovnik",
    duration: "7–10 days",
    distance: "~140 nautical miles",
    difficulty: "Easy",
    descriptionEn: "The classic Croatian sailing route, threading through the Dalmatian island chain. Stops include Brač, Hvar, Korčula, Mljet, and finally Dubrovnik. Consistent summer winds (Maestral) blow from the northwest from late morning, making passages predictable and comfortable. Suitable for beginners and experienced sailors alike.",
    descriptionDe: "Die klassische kroatische Segelroute, die durch die dalmatinische Inselkette führt. Stationen sind Brač, Hvar, Korčula, Mljet und schließlich Dubrovnik. Beständige Sommerwinde (Maestral) wehen ab dem späten Vormittag aus Nordwesten und machen die Überfahrten vorhersehbar und komfortabel. Sowohl für Anfänger als auch für erfahrene Segler geeignet.",
    descriptionFr: "L'itinéraire de navigation croate classique, traversant la chaîne des îles dalmates. Les arrêts incluent Brač, Hvar, Korčula, Mljet et enfin Dubrovnik. Les vents d'été constants (Maestral) soufflent du nord-ouest dès la fin de la matinée, rendant les passages prévisibles et confortables. Convient aussi bien aux débutants qu'aux navigateurs expérimentés.",
    descriptionIt: "La classica rotta velica croata, che attraversa la catena delle isole dalmate. Le tappe includono Brač, Hvar, Korčula, Mljet e infine Dubrovnik. I costanti venti estivi (Maestral) soffiano da nord-ovest dalla tarda mattinata, rendendo le traversate prevedibili e confortevoli. Adatta sia ai principianti che ai velisti esperti.",
    descriptionNl: "De klassieke Kroatische zeilroute, die door de Dalmatische eilandenketen slingert. Stops zijn onder andere Brač, Hvar, Korčula, Mljet en tot slot Dubrovnik. Consistente zomerwinden (Maestral) waaien vanaf de late ochtend uit het noordwesten, wat de oversteken voorspelbaar en comfortabel maakt. Geschikt voor zowel beginners als ervaren zeilers.",
    highlights: ["Hvar Town harbour and nightlife", "Korčula medieval old town", "Mljet National Park", "Dubrovnik city walls", "Blue Cave near Vis (day trip)"],
    startPoint: "Split",
    endPoint: "Dubrovnik",
    gygSearchTerm: "sailing tour Split Dubrovnik Dalmatia Croatia",
  },
  {
    id: "zadar-split",
    name: "Zadar to Split",
    duration: "5–7 days",
    distance: "~100 nautical miles",
    difficulty: "Easy",
    descriptionEn: "A scenic route through the northern Dalmatian islands, passing Ugljan, Dugi Otok, and the Kornati archipelago before arriving in Split via Šibenik. Kornati National Park alone has 89 islands and islets. Calm seas and protected channels make this a relaxed passage.",
    descriptionDe: "Eine malerische Route durch die norddalmatinischen Inseln, vorbei an Ugljan, Dugi Otok und dem Kornati-Archipel, bevor sie über Šibenik in Split ankommt. Der Nationalpark Kornaten allein umfasst 89 Inseln und Inselchen. Ruhige See und geschützte Kanäle machen dies zu einer entspannten Passage.",
    descriptionFr: "Un itinéraire pittoresque à travers les îles du nord de la Dalmatie, passant par Ugljan, Dugi Otok et l'archipel des Kornati avant d'arriver à Split via Šibenik. Le parc national des Kornati compte à lui seul 89 îles et îlots. Des mers calmes et des chenaux protégés en font un passage relaxant.",
    descriptionIt: "Un percorso panoramico attraverso le isole della Dalmazia settentrionale, passando per Ugljan, Dugi Otok e l'arcipelago delle Kornati prima di arrivare a Spalato via Sebenico. Il Parco Nazionale delle Kornati da solo conta 89 isole e isolotti. Mari calmi e canali protetti rendono questa traversata rilassante.",
    descriptionNl: "Een schilderachtige route door de Noord-Dalmatische eilanden, langs Ugljan, Dugi Otok en de Kornati-archipel voordat je via Šibenik in Split aankomt. Het Nationaal Park Kornati alleen al telt 89 eilanden en eilandjes. Rustige zeeën en beschermde kanalen maken dit een ontspannen oversteek.",
    highlights: ["Kornati National Park", "Telašćica Nature Park", "Krka waterfalls (Skradinski Buk)", "Šibenik old town", "Dugi Otok dramatic cliffs"],
    startPoint: "Zadar",
    endPoint: "Split",
    gygSearchTerm: "sailing Kornati islands Croatia boat tour",
  },
  {
    id: "istria-loop",
    name: "Istrian Peninsula Loop",
    duration: "5–7 days",
    distance: "~120 nautical miles",
    difficulty: "Easy",
    descriptionEn: "A relaxed loop around the Istrian peninsula, starting and ending in Rovinj or Pula. Stops include Vrsar, Poreč, Novigrad, Umag, and the Brijuni National Park islands. Waters are generally calm, marinas are excellent, and the food (truffles, Istrian wine, fresh seafood) is outstanding.",
    descriptionDe: "Eine entspannte Runde um die istrische Halbinsel, beginnend und endend in Rovinj oder Pula. Stationen sind Vrsar, Poreč, Novigrad, Umag und die Inseln des Nationalparks Brijuni. Das Wasser ist im Allgemeinen ruhig, die Marinas sind ausgezeichnet und das Essen (Trüffel, istrischer Wein, frische Meeresfrüchte) ist hervorragend.",
    descriptionFr: "Une boucle décontractée autour de la péninsule d'Istrie, commençant et se terminant à Rovinj ou Pula. Les arrêts incluent Vrsar, Poreč, Novigrad, Umag et les îles du parc national de Brijuni. Les eaux sont généralement calmes, les marinas sont excellentes et la nourriture (truffes, vin d'Istrie, fruits de mer frais) est exceptionnelle.",
    descriptionIt: "Un anello rilassato intorno alla penisola istriana, con partenza e arrivo a Rovigno o Pola. Le tappe includono Orsera, Parenzo, Cittanova, Umago e le isole del Parco Nazionale di Brioni. Le acque sono generalmente calme, i porti turistici sono eccellenti e il cibo (tartufi, vino istriano, pesce fresco) è eccezionale.",
    descriptionNl: "Een ontspannen lus om het Istrische schiereiland, beginnend en eindigend in Rovinj of Pula. Stops zijn onder andere Vrsar, Poreč, Novigrad, Umag en de Brijuni National Park eilanden. Het water is over het algemeen rustig, de jachthavens zijn uitstekend en het eten (truffels, Istrische wijn, verse zeevruchten) is uitmuntend.",
    highlights: ["Rovinj old town", "Brijuni National Park", "Pula Roman amphitheatre", "Truffle country excursion", "Malvazija wine tasting"],
    startPoint: "Rovinj",
    endPoint: "Rovinj",
    gygSearchTerm: "sailing Istria Rovinj Brijuni Croatia boat tour",
  },
  {
    id: "split-vis-lastovo",
    name: "Outer Islands Explorer",
    duration: "7–14 days",
    distance: "~180 nautical miles",
    difficulty: "Moderate",
    descriptionEn: "An adventure route to Croatia's outermost and least-visited islands: Vis, Biševo (Blue Cave), and Lastovo Nature Park. Open-sea crossings of 30–50 miles require some experience and comfort offshore, but the reward is pristine nature, near-empty anchorages, and authentic local life.",
    descriptionDe: "Eine Abenteuerroute zu Kroatiens äußersten und am wenigsten besuchten Inseln: Vis, Biševo (Blaue Grotte) und der Naturpark Lastovo. Überquerungen auf offener See von 30–50 Meilen erfordern etwas Erfahrung und Komfort auf See, aber die Belohnung ist unberührte Natur, fast leere Ankerplätze und authentisches lokales Leben.",
    descriptionFr: "Un itinéraire d'aventure vers les îles les plus éloignées et les moins visitées de Croatie : Vis, Biševo (Grotte bleue) et le parc naturel de Lastovo. Les traversées en haute mer de 30 à 50 milles nécessitent une certaine expérience et un confort au large, mais la récompense est une nature vierge, des mouillages presque vides et une vie locale authentique.",
    descriptionIt: "Un percorso d'avventura verso le isole più esterne e meno visitate della Croazia: Vis, Biševo (Grotta Azzurra) e il Parco Naturale di Lastovo. Le traversate in mare aperto di 30-50 miglia richiedono un po' di esperienza e dimestichezza con la navigazione d'altura, ma la ricompensa è una natura incontaminata, ancoraggi quasi deserti e un'autentica vita locale.",
    descriptionNl: "Een avontuurlijke route naar de buitenste en minst bezochte eilanden van Kroatië: Vis, Biševo (Blauwe Grot) en het Lastovo Nature Park. Oversteken op open zee van 30-50 mijl vereisen enige ervaring en comfort buitengaats, maar de beloning is ongerepte natuur, bijna lege ankerplaatsen en een authentiek lokaal leven.",
    highlights: ["Blue Cave on Biševo island", "Komiža fishing village on Vis", "Lastovo Nature Park", "Anchor in deserted bays", "Excellent island wines"],
    startPoint: "Split",
    endPoint: "Split",
    gygSearchTerm: "Blue Cave Vis island Croatia boat trip",
  },
  {
    id: "kvarner-gulf",
    name: "Kvarner Gulf Islands",
    duration: "5–7 days",
    distance: "~90 nautical miles",
    difficulty: "Moderate",
    descriptionEn: "Sailing through the Kvarner Gulf between Krk, Cres, Lošinj, and Rab. The Bura — a powerful north-easterly wind — can make passages challenging but also thrilling. The islands are significantly less visited than Dalmatia and reward with authentic Croatian culture, medieval towns, and great seafood.",
    descriptionDe: "Segeln durch den Kvarner Golf zwischen Krk, Cres, Lošinj und Rab. Die Bura – ein starker Nordostwind – kann die Passagen herausfordernd, aber auch spannend machen. Die Inseln werden deutlich seltener besucht als Dalmatien und belohnen mit authentischer kroatischer Kultur, mittelalterlichen Städten und tollen Meeresfrüchten.",
    descriptionFr: "Navigation dans le golfe du Kvarner entre Krk, Cres, Lošinj et Rab. La Bura — un vent de nord-est puissant — peut rendre les passages difficiles mais aussi passionnants. Les îles sont nettement moins visitées que la Dalmatie et récompensent par une culture croate authentique, des villes médiévales et d'excellents fruits de mer.",
    descriptionIt: "Navigazione nel Golfo del Quarnero tra Veglia, Cherso, Lussino e Arbe. La Bura — un potente vento di nord-est — può rendere le traversate impegnative ma anche entusiasmanti. Le isole sono significativamente meno visitate rispetto alla Dalmazia e offrono un'autentica cultura croata, città medievali e ottimo pesce.",
    descriptionNl: "Zeilen door de Kvarner-golf tussen Krk, Cres, Lošinj en Rab. De Bura — een krachtige noordoostenwind — kan de oversteken uitdagend maar ook spannend maken. De eilanden worden aanzienlijk minder bezocht dan Dalmatië en belonen met authentieke Kroatische cultuur, middeleeuwse steden en geweldige zeevruchten.",
    highlights: ["Krk — Croatia's largest island", "Rab medieval bell towers", "Lošinj aromatherapy trails", "Bura wind sailing", "Rijeka as starting base"],
    startPoint: "Rijeka",
    endPoint: "Rijeka",
    gygSearchTerm: "sailing Kvarner Bay Krk Rab Croatia boat tour",
  },
];

export const SAILING_SEASONS = [
  { month: "May", monthDe: "Mai", monthFr: "Mai", monthIt: "Maggio", monthNl: "Mei", monthHr: "Svibanj", monthPl: "Maj", wind: "Moderate", sea: "Calm", crowds: "Low", rating: 5 },
  { month: "June", monthDe: "Juni", monthFr: "Juin", monthIt: "Giugno", monthNl: "Juni", monthHr: "Lipanj", monthPl: "Czerwiec", wind: "Light–Moderate", sea: "Calm", crowds: "Medium", rating: 5 },
  { month: "July", monthDe: "Juli", monthFr: "Juillet", monthIt: "Luglio", monthNl: "Juli", monthHr: "Srpanj", monthPl: "Lipiec", wind: "Maestral", sea: "Calm", crowds: "High", rating: 4 },
  { month: "August", monthDe: "August", monthFr: "Août", monthIt: "Agosto", monthNl: "Augustus", monthHr: "Kolovoz", monthPl: "Sierpień", wind: "Maestral", sea: "Calm", crowds: "Very High", rating: 3 },
  { month: "September", monthDe: "September", monthFr: "Septembre", monthIt: "Settembre", monthNl: "September", monthHr: "Rujan", monthPl: "Wrzesień", wind: "Light–Moderate", sea: "Calm", crowds: "Low", rating: 5 },
  { month: "October", monthDe: "Oktober", monthFr: "Octobre", monthIt: "Ottobre", monthNl: "Oktober", monthHr: "Listopad", monthPl: "Październik", wind: "Bura possible", sea: "Moderate", crowds: "Very Low", rating: 4 },
];

export const LICENSE_REQUIREMENTS = [
  {
    country: "EU countries",
    countryDe: "EU-Länder", countryFr: "Pays de l'UE", countryIt: "Paesi UE", countryNl: "EU-landen",
    requirement: "ICC (International Certificate of Competence) or equivalent national licence. Croatia accepts most EU national licences directly.",
    requirementDe: "ICC (International Certificate of Competence) oder gleichwertiger nationaler Führerschein. Kroatien akzeptiert die meisten nationalen EU-Lizenzen direkt.",
    requirementFr: "ICC (Certificat international de compétence) ou licence nationale équivalente. La Croatie accepte directement la plupart des licences nationales de l'UE.",
    requirementIt: "ICC (Certificato Internazionale di Competenza) o equivalente patente nazionale. La Croazia accetta direttamente la maggior parte delle patenti nazionali UE.",
    requirementNl: "ICC (Internationaal Vaarvaardigheidsbewijs) of gelijkwaardig nationaal bewijs. Kroatië accepteert de meeste nationale EU-bewijzen rechtstreeks.",
  },
  {
    country: "UK",
    countryDe: "UK", countryFr: "Royaume-Uni", countryIt: "Regno Unito", countryNl: "VK",
    requirement: "RYA Day Skipper or higher. An ICC is required; obtainable through the RYA.",
    requirementDe: "RYA Day Skipper oder höher. Ein ICC ist erforderlich; erhältlich über die RYA.",
    requirementFr: "RYA Day Skipper ou supérieur. Un ICC est requis ; obtenu via la RYA.",
    requirementIt: "RYA Day Skipper o superiore. È richiesto un ICC; ottenibile tramite la RYA.",
    requirementNl: "RYA Day Skipper of hoger. Een ICC is vereist; verkrijgbaar via de RYA.",
  },
  {
    country: "USA / Canada",
    countryDe: "USA / Kanada", countryFr: "États-Unis / Canada", countryIt: "USA / Canada", countryNl: "VS / Canada",
    requirement: "USCG documentation accepted for the vessel; an ICC is recommended for the skipper but not always checked.",
    requirementDe: "USCG-Dokumentation für das Schiff akzeptiert; ein ICC wird für den Skipper empfohlen, aber nicht immer geprüft.",
    requirementFr: "Documentation USCG acceptée pour le navire ; un ICC est recommandé pour le skipper mais pas toujours vérifié.",
    requirementIt: "Documentazione USCG accettata per l'imbarcazione; un ICC è raccomandato per lo skipper ma non sempre verificato.",
    requirementNl: "USCG-documentatie geaccepteerd voor het vaartuig; een ICC wordt aanbevolen voor de schipper maar niet altijd gecontroleerd.",
  },
  {
    country: "Vessels under 5m",
    countryDe: "Fahrzeuge unter 5 m", countryFr: "Embarcations de moins de 5 m", countryIt: "Imbarcazioni sotto i 5 m", countryNl: "Vaartuigen onder 5 m",
    requirement: "No licence required, but experience is assumed. Charter companies may request an experience log.",
    requirementDe: "Kein Führerschein erforderlich, aber Erfahrung wird vorausgesetzt. Charterunternehmen können einen Erfahrungsnachweis verlangen.",
    requirementFr: "Aucune licence requise, mais l'expérience est supposée. Les sociétés de charter peuvent demander un journal d'expérience.",
    requirementIt: "Nessuna patente richiesta, ma l'esperienza è presupposta. Le società di charter possono richiedere un registro delle esperienze.",
    requirementNl: "Geen bewijs vereist, maar ervaring wordt verondersteld. Chartermaatschappijen kunnen een ervaringslogboek opvragen.",
  },
];
